import { render, staticRenderFns } from "./SealApprovedetail.vue?vue&type=template&id=8731b14a&scoped=true&"
import script from "./SealApprovedetail.vue?vue&type=script&lang=js&"
export * from "./SealApprovedetail.vue?vue&type=script&lang=js&"
import style0 from "./SealApprovedetail.vue?vue&type=style&index=0&id=8731b14a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8731b14a",
  null
  
)

export default component.exports